/** Check the saved, authorized projection, never unsaved checkbox state. */
export function dispatchBlockers(order: { ready: boolean; public_code?: string | null; public_code_printed?: boolean }): string[] {
  const reasons: string[] = [];
  if (!order.public_code?.trim()) reasons.push('A checked Deal ID has not been assigned.');
  if (order.public_code_printed !== true) reasons.push('Staff must confirm the Deal ID is printed on the invoice and dispatch papers.');
  if (!order.ready) reasons.push('Complete customer details, delivery address and products are required.');
  return reasons;
}
